import { render, staticRenderFns } from "./StoreFooter.vue?vue&type=template&id=c45ff426&scoped=true&"
import script from "./StoreFooter.vue?vue&type=script&lang=js&"
export * from "./StoreFooter.vue?vue&type=script&lang=js&"
import style0 from "./StoreFooter.vue?vue&type=style&index=0&id=c45ff426&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45ff426",
  null
  
)

export default component.exports